import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { DefaultComplianceSettingsUpdateModal } from './DefaultComplianceSettingsUpdateModal'

type DefaultComplianceSettingsCreateActivityProps = {
  refetchQuery: string
  defaultComplianceExtraFieldSettingId: string
}

export const DefaultComplianceSettingsUpdateActivity: ActivityComponent<
  DefaultComplianceSettingsCreateActivityProps
> = (data) => {
  const { open, closeActivity } = useActivity()

  return (
    <DefaultComplianceSettingsUpdateModal
      isOpen={open}
      onClose={closeActivity}
      refetchQuery={data.refetchQuery}
      defaultComplianceExtraFieldSettingId={Number(data.defaultComplianceExtraFieldSettingId)}
    />
  )
}
